<template>
    <div>
        <block :value="loading"></block>
        <v-card class="pa-4 ma-1 white">
        <!-- Table -->
         <DateFilter ref="childRef" @reset-data="getAllTransferRequests" 
            @filtered-data="handleDateFilter" :filterEndpoint="getTransferRequestsFiltered"
            :isFilteredByOutsource="false" :search="search"
            @filtered-loading="loading = $event" />
        <GeneralFilter class="background border-box" entity="transferencia"
            :filterEndpoint="filterTransferRequestsWithStatus" :search="search"
            @emptyFilter="getAllTransferRequests" @filtered="filterHandler"
            @loading="loading = $event"
            :showAllRecords="showAllRecords">
            <template #options>
                <v-checkbox
                    :input-value="showAllRecords"
                    @change="onShowAllRecordsChange"
                    label="Mostrar todos los registros (sin límite de 100)"
                    dense
                    hide-details="auto"
                />
            </template>
            <DxDataGrid class="isScrolledByGeneralFilter" :data-source="transferApplication" ref="dxDataGridTransferRequest" key="ID_Transfer"
                :show-row-line="ShowRowLines" :column-auto-width="true" :show-border="showBorders" :row-alternation-enabled="rowAlternationEnabled"
                @exporting="onExporting" style="max-height: 600px">
                <DxExport :enabled="true" />
                <DxScrolling row-rendering-mode="virtual" />
                <DxPaging :page-size="10" />
                <DxPager :show-page-size-selector="true" :allowed-page-sizes="[10, 25, 50, 100]" :show-info="true" />
                <DxColumn :width="100" cell-template="show-template" caption="" v-if="$store.getters['rolesUser/getCustomRole'](116)"></DxColumn>
                <DxColumn data-field="ID_Request" caption="ID"></DxColumn>
                <DxColumn cell-template="status-template" caption="Estado"></DxColumn>
                <DxColumn data-field="RequestDate" caption="Fecha de solicitud"></DxColumn>
                <DxColumn data-field="DateTransfer" caption="Fecha de Aprobación"></DxColumn>
                <DxColumn data-field="OriginWarehouse" caption="Origen"></DxColumn>
                <DxColumn data-field="DestinyWarehouse" caption="Destino"></DxColumn>
                <DxColumn data-field="ReqName" caption="Usuario Solicita"></DxColumn>
                <DxColumn data-field="userName" caption="Usuario Aprobación"></DxColumn>
                <template #show-template="{ data }">
                    <a href="#" class="mx-1" @click.prevent.stop="showTransferDetails(data)">
                        <v-icon color="primary">mdi-eye</v-icon>
                    </a>
                </template>
                <template #status-template="{ data }">
                    <div v-if="data.data.RequestStatus == 0">
                        <v-icon color="orange">mdi-clock-outline</v-icon> Pendiente
                    </div>
                    <div v-else-if="data.data.RequestStatus == 1">
                        <v-icon color="green">mdi-check-circle</v-icon> Realizado
                    </div>
                    <div v-else-if="data.data.RequestStatus == 2">
                        <v-icon color="red">mdi-close-circle</v-icon> No disponible
                    </div>
                    <div v-else-if="data.data.RequestStatus == 3">
                        <v-icon color="blue">mdi-truck-delivery</v-icon> Enviado
                    </div>
                    <div v-else>
                        <v-icon>mdi-alert-circle</v-icon> Error
                    </div>
                </template>
            </DxDataGrid>
        </GeneralFilter>
        <!-- Table -->

        <!-- Modal -->
        <v-dialog v-model="showModal" max-width="1024px" scrollable>
            <TransferDetails :transferData="transferData" :isTransferApplication="true"
                @close-modal="showModal = $event" @reload-table="reloadTable" delete-allowed />
        </v-dialog>
        <!-- Modal -->
        </v-card>
    </div>
</template>

<script>
import { DxDataGrid, DxExport, DxColumn, DxScrolling, DxPaging, DxPager } from 'devextreme-vue/data-grid'
import { formatDate } from '../../../helpers/formatDate'
import { printToExcel } from '../../../helpers/printToexcel'
import TransferDetails from '../TransferDetails.vue'
import GeneralFilter from '@/components/GeneralFilter.vue'
import DateFilter from '../../../components/DateFilter.vue'
export default {
    name: 'SearchTransferApplicationTable',

    components: {
        DxDataGrid,
        DxColumn,
        DxExport,
        DxScrolling,
        DxPaging,
        DxPager,
        TransferDetails,
        GeneralFilter,
        DateFilter,
    },

    props: ['win', 'reload'],

    data() {
        return {
            ShowRowLines: true,
            showBorders: true,
            rowAlternationEnabled: true,
            showModal: false,
            transferApplication: [],
            transferData: null,
            showAllRecords: false,
            loading: false,
            search: {
                filter: null
            },
            // Filtros para el backend - excluimos estado 3 (Enviado)
            backendFilters: {
                requestStatus: '0,1,2' // Estados: Pendiente, Realizado, No disponible
            }
        }
    },

    watch: {
        reload(newData) {
            console.log("Reload detected in SearchTransferApplicationTable:", newData);
            if (newData) {
                this.getAllTransferRequests()
                this.setReloadData()
            }
        },
    },

    methods: {
        async showTransferDetails(data) {
            if (this.loading) return;

            this.loading = true;
            try {
                const detail = await this.$API.inventoryTransfer.getOneTransferRequest(
                    data.data.ID_Request
                );

                this.transferData = {
                    ...data,
                    data: {
                        ...data.data,
                        ...detail,
                        RequestDate: data.data.RequestDate || detail.RequestDate,
                        DateTransfer: data.data.DateTransfer || detail.DateTransfer
                    }
                };
                this.showModal = true;
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },
        // Método para actualizar filtros del backend
        updateBackendFilters(filters) {
            this.backendFilters = { ...this.backendFilters, ...filters };
            this.getAllTransferRequests();
        },
        // Método para filtrar con GeneralFilter manteniendo los filtros de estado
        async filterTransferRequestsWithStatus(filterParams) {
            // Combinar filtro de búsqueda con filtro de estado
            const params = {
                ...filterParams,
                requestStatus: this.backendFilters.requestStatus
            };
            return await this.$API.inventoryTransfer.filterTransferRequests(params);
        },
        // Método para filtrar por fechas desde DateFilter
        async getTransferRequestsFiltered(params) {
            console.log('Filtrando con parámetros:', params);
            const { start, end } = params;
            const filters = {
                ...this.backendFilters
            };
            // Solo agregar fechas si están presentes
            if (start && end) {
                filters.startDate = start;
                filters.endDate = end;
            }
            filters.showAllRecords = this.showAllRecords;
            const response = await this.$API.inventoryTransfer.getAllTransferRequestsHistory(filters);
            return response.map(transfer => ({
                ...transfer,
                RequestDate: formatDate(transfer.RequestDate),
                DateTransfer: transfer.DateTransfer ? formatDate(transfer.DateTransfer) : null,
            }));
        },
        handleDateFilter(filteredData) {
            // El DateFilter ya devuelve los datos formateados
            this.transferApplication = filteredData;
        },
        onExporting(e) {
            printToExcel(e, 'Solicitudes de transferencias de inventario')
        },
        async getAllTransferRequests() {
            this.loading = true;
            try {
                const response = await this.$API.inventoryTransfer.getAllTransferRequestsHistory({
                    ...this.backendFilters,
                    showAllRecords: this.showAllRecords
                });
                this.transferApplication = response.map(transfer => ({
                    ...transfer,
                    RequestDate: formatDate(transfer.RequestDate),
                    DateTransfer: transfer.DateTransfer ? formatDate(transfer.DateTransfer) : null,
                }));
            } catch (error) {
                console.log('Error al obtener transferencias:', error)
            } finally {
                this.loading = false;
            }
        },
        onShowAllRecordsChange(value) {
            this.showAllRecords = value;
            this.getAllTransferRequests();
        },
        reloadTable() {
            this.getAllTransferRequests()
            this.$refs['dxDataGridTransferRequest'].instance.refresh()
        },
        filterHandler(response) {
            // Ya no necesitamos filtrar estado 3, solo formatear fechas
            this.transferApplication = response.map(transfer => ({
                ...transfer,
                RequestDate: formatDate(transfer.RequestDate),
                DateTransfer: transfer.DateTransfer ? formatDate(transfer.DateTransfer) : null,
            }))
        },
    },
}
</script>
